import { useMutation } from "@tanstack/react-query";
import { addMatrixColumn, type AddMatrixColumnInput } from "@/domains/matrix";
import { useMatrixInvalidation } from "./use-matrix-invalidation";

export function useAddMatrixColumn(collectionId: string) {
  const { invalidateDetailAndList } = useMatrixInvalidation(collectionId);

  return useMutation({
    mutationFn: (input: AddMatrixColumnInput) =>
      addMatrixColumn(collectionId, input),
    onSuccess: invalidateDetailAndList,
  });
}
